import React, { useEffect, useState } from "react";
import {
  Avatar,
  List,
  Form,
  Input,
  Button,
  message,
  Modal,
  Select,
  Flex,
} from "antd";
import { CharacteristicsService } from "deliziora-client-module/client-web/services/CharacteristicsService";
import UploadImages from "../UploadImages/Upload";
import "./NewCaracteristicsAdmin.css";

const NewCharacteristicsAdmin = () => {
  const [characteristics, setCharacteristics] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleTwo, setVisibleTwo] = useState(false);
  const [characteristicToDelete, setCharacteristicToDelete] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [images, setImages] = useState("");
  const [form] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [inputValue, setInputValue] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [editedCharacteristic, setEditedCharacteristic] = useState(null); // Estado para a característica editada

  useEffect(() => {
    const fetchCharacteristics = () => {
      CharacteristicsService.returnAllCharacteristics()
        .then((response) => {
          setCharacteristics(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchCharacteristics();
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleDelete = () => {
    if (characteristicToDelete) {
      CharacteristicsService.deleteCharacteristicsById(
        characteristicToDelete._id.$oid
      )
        .then(() => {
          setCharacteristics((prevCharacteristics) =>
            prevCharacteristics.filter(
              (item) => item._id.$oid !== characteristicToDelete._id.$oid
            )
          );
          message.success("Característica excluída com sucesso");
        })
        .catch((error) => {
          console.error(error);
          message.error("Erro ao excluir características");
        });
    }
    setVisible(false);
    setCharacteristicToDelete(null);
  };

  const showDeleteModal = (characteristic) => {
    setCharacteristicToDelete(characteristic);
    setVisible(true);
  };

  const hideDeleteModal = () => {
    setVisible(false);
    setCharacteristicToDelete(null);
  };

  const onFinish = (values) => {
    CharacteristicsService.addCharacteristics({
      name: values.characteristics,
      icon: images,
    })
      .then(() => {
        CharacteristicsService.returnAllCharacteristics()
          .then((response) => {
            setCharacteristics(response.data);
            message.success("Característica adicionada com sucesso");
            form.resetFields();
            setFileList([]);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        message.error("Erro ao adicionar característica");
      });
  };

  const handleDataReceived = (value) => {
    setImages(value);
  };

  const handleEdit = (characteristic) => {
    setEditedCharacteristic(characteristic);
    console.log(characteristic); // Definir a característica editada quando o usuário clicar em editar
    setVisibleTwo(true); // Abrir o modal de edição
  };

  const handleUpdate = (values) => {
    const id = editedCharacteristic._id.$oid;
    console.log({
      name: values.characteristics,
      id_characteristics: id,
      icon: editedCharacteristic.icon,
    });
    CharacteristicsService.updateCharacteristicsById({
      name: values.characteristics,
      id_characteristics: id,
      icon: editedCharacteristic.icon,
    })
      .then(() => {
        message.success("Característica atualizada com sucesso");
        CharacteristicsService.returnAllCharacteristics()
          .then((response) => {
            setCharacteristics(response.data);
            setVisibleTwo(false);
            setEditedCharacteristic(null);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
        message.error("Erro ao atualizar característica");
      });
  };

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMobile(/mobile|android|iphone|ipad/.test(userAgent));
  }, []);

  formEdit.setFieldValue("characteristics", editedCharacteristic?.name);

  return (
    <>
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: "100vh", maxWidth: "100vw" }}
      >
        <List
          itemLayout="horizontal"
          className="categories_list"
          dataSource={characteristics}
          renderItem={(item) => (
            <List.Item
              actions={[
                <a
                  className="categories_list_edit"
                  onClick={() => handleEdit(item)}
                >
                  Editar
                </a>,
                <a
                  className="categories_list_delete"
                  onClick={() => showDeleteModal(item)}
                >
                  Apagar
                </a>,
              ]}
            >
              <List.Item.Meta
                title={<div>{item.name}</div>}
                avatar={<Avatar src={item.icon} />}
              />
            </List.Item>
          )}
        />
        <Modal
          title="Editar Característica"
          open={visibleTwo}
          onOk={() => formEdit.submit()}
          onCancel={() => {
            setVisibleTwo(false);
            form.resetFields();
            setEditedCharacteristic(null);
          }}
        >
          <Form form={formEdit} onFinish={handleUpdate}>
            <Form.Item
              label="Nome da Característica"
              name="characteristics"
              rules={[
                {
                  required: true,
                  message: "Por favor insira o nome da característica",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
        <h2 style={{ width: "78vw", textAlign: "center", marginTop: "1rem" }}>
          Insira uma nova característica aqui
        </h2>
        <Flex style={{ padding: "1rem" }}>
          <UploadImages
            onDataReceived={handleDataReceived}
            setImagesList={setImages}
            fileList={fileList}
            setFileList={setFileList}
          />
        </Flex>
        <Form
          name="basic"
          style={{
            maxWidth: "90vw",
            alignItems: "center",
            justifyContent: "center",
          }}
          onFinish={onFinish}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Nova Característica"
            name="characteristics"
            rules={[
              {
                required: true,
                message: "Por favor insira uma característica",
              },
            ]}
          >
            <Input placeholder="Nova Característica" allowClear />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
        <Modal
          title="Confirmar exclusão"
          visible={visible}
          onOk={handleDelete}
          onCancel={hideDeleteModal}
        >
          <p>
            Tem certeza que deseja excluir a característica{" "}
            {characteristicToDelete && characteristicToDelete.name}?
          </p>
        </Modal>
      </Flex>
    </>
  );
};

export default NewCharacteristicsAdmin;
